import { useI18n } from "@/context/I18nContext";
import { PawPrint } from "@phosphor-icons/react";

export default function LanguagePicker() {
    const { pickerNeeded, confirmPicker, languages, lang } = useI18n();
    if (!pickerNeeded) return null;
    return (
        <div className="fixed inset-0 z-[100] bg-paw-ink/50 backdrop-blur-sm grid place-items-center px-4" data-testid="lang-picker">
            <div className="card-soft w-full max-w-md p-6 sm:p-8 text-center">
                <span className="inline-grid place-items-center w-12 h-12 rounded-full bg-paw-forest text-white mb-3">
                    <PawPrint size={26} weight="fill" />
                </span>
                <h2 className="font-display text-2xl sm:text-3xl tracking-tight">Choose your language</h2>
                <p className="text-sm text-paw-ink2 mt-1">Выберите / اختر / Choisissez / Elige</p>
                <div className="grid grid-cols-2 gap-3 mt-6">
                    {languages.map((L) => (
                        <button
                            key={L.code}
                            data-testid={`lang-option-${L.code}`}
                            onClick={() => confirmPicker(L.code)}
                            className={`rounded-2xl border px-4 py-4 text-left transition-all duration-300 hover:-translate-y-0.5 hover:shadow-hover ${lang === L.code ? "border-paw-forest ring-2 ring-paw-forest/20" : "border-paw-line"} bg-white dark:bg-paw-ink/60 dark:border-white/10`}
                        >
                            <div className="text-3xl">{L.flag}</div>
                            <div className="mt-2 font-display text-lg text-paw-ink dark:text-paw-bone">{L.label}</div>
                        </button>
                    ))}
                </div>
                <button
                    onClick={() => confirmPicker(lang)}
                    data-testid="lang-picker-continue"
                    className="btn-primary mt-6 w-full"
                >
                    Continue
                </button>
            </div>
        </div>
    );
}
